@if (!isAddRole) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Role Management</span>
      </div>
      <!-- Redirect Button -->
      <div class="button-group">
        <button
          class="primary-button"
          type="button"
          (click)="addRole('add', null)"
        >
          Add Role
          <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      </div>
    </div>

    <div class="component-container">
      <!-- List Section -->
      <form [formGroup]="addRoleForm">
        <div class="component-header">
          <h6 class="component-title">Role List</h6>
          <div class="component-actions">
            <app-common-search
              [initialSearchValue]="roleListSearch?.get('searchRole')?.value"
              (searchSubmit)="onSearch($event)"
              matTooltip="Role Name"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Role Name</th>
                <th>Role Type</th>
                <th>Role Hierarchy Level</th>
                <th>Group Name</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            @if (listOfRole.length > 0) {
              <tbody>
                @for (
                  item of listOfRole
                    | paginate
                      : {
                          id: 'role_pagination',
                          itemsPerPage: size,
                          currentPage: page,
                          totalItems: totalLength,
                        };
                  track item
                ) {
                  <tr>
                    <td>
                      {{ item.userRole ? item.userRole : '--' }}
                    </td>
                    <td>
                      {{ item.roleType ? item.roleType : '--' }}
                    </td>
                    <td>
                      {{
                        item.hierarchyLevel || item.hierarchyLevel === 0
                          ? item.hierarchyLevel
                          : '--'
                      }}
                    </td>
                    <td>
                      {{ item.groupId?.groupName || '--' }}
                    </td>
                    <td>
                      {{
                        item.createdAt
                          ? (item.createdAt | date: 'dd/MM/yyyy')
                          : '--'
                      }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        <button
                          type="button"
                          class="primary-button view-button"
                          (click)="prePopulation(item._id)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="primary-button delete-button"
                          (click)="deleteRole(item.userRole)"
                        >
                          <mat-icon class="btn-icon">delete</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (listOfRole.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          @if (listOfRole.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalLength"
              [pageSize]="size"
              [currentPage]="page"
              [totalPages]="totalLength"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </form>
    </div>
  </div>
}
@if (isAddRole) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="toggleIsAddRole()"
          tabindex="0"
          (keydown.enter)="toggleIsAddRole()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        @if (updateButton) {
          <div
            class="action-button reload-button"
            (click)="prePopulation(rid)"
            tabindex="0"
            (keydown.enter)="prePopulation(rid)"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
        }
        @if (submitButton) {
          <div
            class="action-button reload-button"
            (click)="addRole('add', null)"
            tabindex="0"
            (keydown.enter)="addRole('add', null)"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
        }
        <span class="page-title">Role Management</span>
      </div>
    </div>

    <div class="component-container">
      <form [formGroup]="addRoleForm" novalidate>
        <!-- List Section -->
        <div class="component-header">
          @if (updateButton) {
            <h6 class="component-title">Update User Role</h6>
          }
          @if (submitButton) {
            <h6 class="component-title">Add User Role</h6>
          }
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Form Section -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="userRole" class="form-label">Role Name</label>
              <mat-form-field appearance="outline">
                <mat-label>Role Name</mat-label>
                <input
                  matInput
                  id="userRole"
                  type="text"
                  formControlName="userRole"
                  placeholder=" Enter Role Name"
                  [readonly]="updateButton"
                  required
                />
                @if (
                  addRoleForm.controls['userRole'].touched &&
                  addRoleForm.controls['userRole'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      addRoleForm.controls['userRole'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  addRoleForm.controls['userRole'].touched &&
                  addRoleForm.controls['userRole'].errors
                    ?.nonNumericNoSpecialChars
                ) {
                  <mat-error>
                    {{
                      addRoleForm.controls['userRole'].errors
                        ?.nonNumericNoSpecialChars
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="roleType" class="form-label">Role Type</label>
              <mat-form-field appearance="outline">
                <mat-label>Role Type</mat-label>
                <mat-select
                  formControlName="roleType"
                  (selectionChange)="onRoleTypeChange($event)"
                >
                  @for (role of roleTypeList; track role) {
                    <mat-option [value]="role.value">
                      {{ role.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  addRoleForm.controls['roleType'].touched &&
                  addRoleForm.controls['roleType'].errors?.['required']
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
            @if (viewRoleGroup) {
              <div class="form-group">
                <label for="groupId" class="form-label">Role Group</label>
                <mat-form-field appearance="outline">
                  <mat-label>Role Group</mat-label>
                  <mat-select
                    formControlName="groupId"
                    (selectionChange)="onRoleGroupChange($event)"
                  >
                    @for (role of roleGroupList; track role) {
                      <mat-option [value]="role._id">
                        {{ role.groupName }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (
                    addRoleForm.controls['groupId'].touched &&
                    addRoleForm.controls['groupId'].invalid
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>
        </div>

        <!-- Permission -->
        @if (viewRoleGroup) {
          <div class="component-container">
            <div class="component-subheader">
              <h6 class="component-title">Select Permission</h6>
            </div>
            <div class="component-separator"></div>
            <div class="component-body">
              <table>
                <tr>
                  <th>Pages</th>
                  <th>
                    <button
                      for="onSelectAllPagesChange"
                      type="button"
                      style="cursor: pointer"
                      (click)="onSelectAllPagesChange(!selectAll)"
                      tabindex="0"
                      (keypress.enter)="onSelectAllPagesChange(!selectAll)"
                    >
                      Select All
                    </button>
                  </th>
                  <th>
                    <button
                      for="onSelectViewPagesChange"
                      type="button"
                      style="cursor: pointer"
                      (click)="onSelectViewPagesChange(!viewAll)"
                      tabindex="0"
                      (keypress.enter)="onSelectViewPagesChange(!viewAll)"
                    >
                      View
                    </button>
                  </th>
                  <th>
                    <button
                      for="onSelectCreatePagesChange"
                      type="button"
                      style="cursor: pointer"
                      (click)="onSelectCreatePagesChange(!createAll)"
                      tabindex="0"
                      (keypress.enter)="onSelectCreatePagesChange(!createAll)"
                      [disabled]="!viewAll"
                    >
                      Create
                    </button>
                  </th>
                  <th>
                    <button
                      for="onSelectUpdatePagesChange"
                      style="cursor: pointer"
                      (click)="onSelectUpdatePagesChange(!updateAll)"
                      type="button"
                      tabindex="0"
                      (keypress.enter)="onSelectUpdatePagesChange(!updateAll)"
                      [disabled]="!viewAll"
                    >
                      Update
                    </button>
                  </th>
                  <th>
                    <button
                      for="onSelectDeletePagesChange"
                      style="cursor: pointer"
                      (click)="onSelectDeletePagesChange(!deleteAll)"
                      type="button"
                      tabindex="0"
                      (keypress.enter)="onSelectDeletePagesChange(!deleteAll)"
                      [disabled]="!viewAll"
                    >
                      Delete
                    </button>
                  </th>
                </tr>
                <tbody>
                  @for (
                    item of allPages
                      | paginate
                        : {
                            id: 'alert_pagination',
                            itemsPerPage: 3,
                            currentPage: 1,
                            totalItems: 3,
                          };
                    track item
                  ) {
                    <tr>
                      <td>
                        <div class="table-cell">
                          <div class="header">
                            @if (item.isTab) {
                              <span>&nbsp;&nbsp;</span>
                            }
                            {{ item.pageName }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          value="{{ item.pageName }}"
                          (change)="onSelectAllChange($event)"
                          id="{{ item.id }}"
                          [checked]="item.selectAll"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          value="{{ item.pageName }}"
                          (change)="onViewChange($event)"
                          id="{{ item.id }}"
                          [checked]="item.view"
                        />
                        @if (getActionInfo(item.pageName, 'view'); as info) {
                          <app-info-tooltip
                            [description]="info"
                          ></app-info-tooltip>
                        }
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          [disabled]="!item.view"
                          value="{{ item.pageName }}"
                          id="{{ item.id }}"
                          (change)="onCreateChange($event)"
                          [checked]="item.create"
                        />
                        @if (getActionInfo(item.pageName, 'create'); as info) {
                          <app-info-tooltip
                            [description]="info"
                          ></app-info-tooltip>
                        }
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          [disabled]="!item.view"
                          value="{{ item.pageName }}"
                          (change)="onUpdateChange($event)"
                          [checked]="item.update"
                        />
                        @if (getActionInfo(item.pageName, 'update'); as info) {
                          <app-info-tooltip
                            [description]="info"
                          ></app-info-tooltip>
                        }
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          [disabled]="!item.view"
                          value="{{ item.pageName }}"
                          (change)="onDeleteChange($event)"
                          [checked]="item.delete"
                        />
                        @if (getActionInfo(item.pageName, 'delete'); as info) {
                          <app-info-tooltip
                            [description]="info"
                          ></app-info-tooltip>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          <div class="button-group">
            @if (submitButton) {
              <button
                type="button"
                [disabled]="addRoleForm.invalid"
                (click)="saveRole()"
                class="submit-button"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            }
            @if (updateButton) {
              <button
                type="button"
                [disabled]="addRoleForm.invalid"
                (click)="updateRole()"
                class="edit-button"
              >
                Update <mat-icon class="btn-icon">edit</mat-icon>
              </button>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
}
